//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Portal } from '@linusborg/vue-simple-portal';
import Snackbar from '../../../../components/snackbar';

export default {
  components: {
    Portal,
  },
  extends: Snackbar,
};
